module.exports = __webpack_public_path__ + "img/boxergirl2.jpg";